import type { ZudokuConfig } from "zudoku";

/**
 * Developer Portal Configuration
 * For more information, see:
 * https://zuplo.com/docs/dev-portal/zudoku/configuration/overview
 */
const config: ZudokuConfig = {
  site: {
    title: "CEORater API",
    logo: {
      src: {
        light: "https://www.ceorater.com/android-chrome-512x512.png",
        dark: "https://www.ceorater.com/android-chrome-512x512.png",
      },
      width: "40px",
    },
  },
  metadata: {
    title: "CEORater API - Developer Portal",
    description: "Programmatic access to CEO performance metrics and company data",
  },
  navigation: [
    {
      type: "category",
      label: "Documentation",
      items: [
        {
          type: "category",
          label: "Getting Started",
          icon: "sparkles",
          items: [
            {
              type: "doc",
              file: "introduction",
            },
            {
              type: "doc",
              file: "markdown",
            },
          ],
        },
        {
          type: "category",
          label: "Useful Links",
          collapsible: false,
          icon: "link",
          items: [
            {
              type: "link",
              label: "Zuplo Docs",
              to: "https://zuplo.com/docs/dev-portal/introduction",
            },
            {
              type: "link",
              label: "Developer Portal Docs",
              to: "https://zuplo.com/docs/dev-portal/introduction",
            },
          ],
        },
      ],
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
    },
  ],
  redirects: [{ from: "/", to: "/api" }],
  apis: [
    {
      type: "file",
      input: "../config/routes.oas.json",
      path: "api",
    },
  ],
  authentication: {
    type: "auth0",
    domain: "auth.ceorater.com",
    clientId: "BWXbqb6K6ZPHdDXJ5CUQ4w3FUIkTmEuB",
    audience: "https://api.ceorater.com",
    scopes: ["openid", "profile", "email"],
  },
  apiKeys: {
    enabled: true,
  },
};

export default config;